/*
 * @Author: zhushitao
 * @Date: 2021-10-28 14:56:55
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-10-28 14:56:56
 * @Description:
 */

import { Subject } from 'rxjs';

import { ITypeError } from './type';

export const onErrorSubject: Subject<ITypeError> = new Subject();
